import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

interface MovieCardProps {
  movie: Movie;
  showGenres?: boolean;
}

export default function MovieCard({ movie, showGenres = false }: MovieCardProps) {
  return (
    <Link to={`/movie/${movie.id}`} className="card-hover group block">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`电影《${movie.title}》海报`}
          title={`${movie.title} ${movie.genres.join(' ')} 高清电影`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90" />

        <span className="absolute left-2 top-2 flex items-center gap-0.5 rounded-md bg-primary-500 px-1.5 py-0.5 text-[11px] font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
          {movie.rating.toFixed(1)}
        </span>

        <span className="absolute right-2 top-2 rounded-md bg-background-50/70 px-1.5 py-0.5 text-[11px] text-foreground-800 backdrop-blur">
          {movie.year}
        </span>

        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50 backdrop-blur">
            <i className="ri-play-fill pl-0.5 text-xl" aria-hidden="true"></i>
          </span>
        </span>

        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="flex flex-wrap gap-1">
            {movie.genres.slice(0, 2).map((genre) => (
              <span
                key={genre}
                className="whitespace-nowrap rounded bg-background-50/55 px-1.5 py-0.5 text-[10px] text-foreground-700 backdrop-blur"
              >
                {genre}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-500 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1 flex items-center gap-1.5 truncate text-xs text-foreground-500">
          <span className="whitespace-nowrap">{movie.region}</span>
          <span className="h-1 w-1 shrink-0 rounded-full bg-foreground-500/60" />
          <span className="truncate">{movie.enTitle}</span>
        </p>
        {showGenres && (
          <p className="mt-1 truncate text-xs text-foreground-500">{movie.director} 导演</p>
        )}
      </div>
    </Link>
  );
}